import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  ToggleButton,
  ToggleButtonGroup,
  CircularProgress,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../redux/store/appStore';
import { STATUS } from '../../utils/status';
import { useStyles } from '../../assets/styles/listTableStyle';
import TableRowItem from './analyseTableRowItem';
import Error from '../error/error';
import { TableCellHead } from '../table/tableCell';
import { useParams } from 'react-router-dom';
import {
  createAnalyseBulkVendor,
  createAnalyseBulkVendorByTaskIDs,
} from '../../redux/slices/vendorList';

interface DataInformationTableProps {
  formDataArray: any;
  selectedType?: string;
}

const VendorBulkAlocationAnalyseTable: React.FC<DataInformationTableProps> = ({
  formDataArray,
  selectedType,
}) => {
  const classes = useStyles();
  const [tableSwitch, setTableSwitch] = useState('CURRENT');
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();

  const analyseData = useSelector((state: RootState) => state.vendorList.analyse);
  const createAnalyseStatus = useSelector((state: RootState) => state.vendorList.createAnalyseStatus);

  const createVendorAnalyseStatusTaskIDs = useSelector(
    (state: RootState) => state.vendorList.createAnalyseStatusTaskIDs
  );
  const createVendorAnalyseDataTaskIDs = useSelector(
    (state: RootState) => state.vendorList.analyseTaskIDs
  );

  const fileType3 = useSelector((state: RootState) => state.fileAllocation.file);

  const headers = [
    'VENDOR NAME',
    ...(tableSwitch !== 'ALL' ? ['STAGE NAME'] : []),
    'AVAILABLE TASKS AFTER THIS ALLOCATION',
    'TOTAL TASKS ALLOCATED TILL NOW',
    'TOTAL ALLOCATED TASKS TO EXPERTS BY THIS VENDOR',
  ];

  const isType2 = selectedType === 'Type 2';
  const isType3 = selectedType === 'Type 3';

  const status = isType2 ? createAnalyseStatus : createVendorAnalyseStatusTaskIDs;
  const data = isType2 ? analyseData : createVendorAnalyseDataTaskIDs;

  const handleChangeToggle = (event: any, table: string) => {
    if (table !== null) {
      setTableSwitch(table);

      if (isType2) {
        const payload = {
          project_id: id,
          data: formDataArray.map((item: { vendor: string[]; task_count: string; type: string[] }) => ({
            vendor_id: item.vendor?.[0],
            task_count: Number(item.task_count),
            stages: Array.isArray(item.type) ? item.type.map((stageId) => Number(stageId)) : [],
          })),
          analyse_all: table === 'ALL',
        };

        dispatch(createAnalyseBulkVendor({ payload }));
      } else if (isType3) {
        const formData = new FormData();
        formData.append('project_id', id || '');
        formData.append('analyse_all', table === 'ALL' ? 'true' : 'false');
        if (fileType3) {
          formData.append('file', fileType3);
        }
        dispatch(createAnalyseBulkVendorByTaskIDs({ payload: formData }));
      }
    }
  };

  return (
    <>
      <ToggleButtonGroup
        color="standard"
        value={tableSwitch}
        exclusive
        onChange={handleChangeToggle}
      >
        <ToggleButton
          value="CURRENT"
          style={{
            border: 'none',
            fontFamily: 'Montserrat',
            fontSize: '14px',
            fontWeight: 600,
            lineHeight: '24px',
            color: tableSwitch === 'CURRENT' ? '#03BBD2' : '#6C6C6C',
            borderBottom: tableSwitch === 'CURRENT' ? '3px solid #03BBD2' : 'none',
            backgroundColor: 'inherit',
            textTransform: 'none',
          }}
        >
          Current Project
        </ToggleButton>
        <ToggleButton
          value="ALL"
          style={{
            border: 'none',
            fontFamily: 'Montserrat',
            fontSize: '14px',
            fontWeight: 600,
            lineHeight: '24px',
            color: tableSwitch === 'ALL' ? '#03BBD2' : '#6C6C6C',
            borderBottom: tableSwitch === 'ALL' ? '3px solid #03BBD2' : 'none',
            backgroundColor: 'inherit',
            textTransform: 'none',
          }}
        >
          All Project
        </ToggleButton>
      </ToggleButtonGroup>

      <TableContainer sx={{ backgroundColor: 'white', minHeight: '200px' }}>
        {status === STATUS.PENDING && (
          <div className={classes.progressDiv}>
            <CircularProgress />
          </div>
        )}
        {status === STATUS.SUCESS && (
          <>
            <Table className={classes.tableContainer} aria-label="simple table">
              <TableHead>
                {headers.map((header) => (
                  <TableCellHead key={header}>{header}</TableCellHead>
                ))}
              </TableHead>
              <TableBody>
                {data && data.length > 0 ? (
                  data.map((row: any) => (
                    <TableRowItem key={row.id} row={row} showStageName={tableSwitch !== 'ALL'}/>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={6} className={classes.noUsersMessage}>
                      <Error message="There are no users added as of yet." />
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </>
        )}
      </TableContainer>
    </>
  );
};

export default VendorBulkAlocationAnalyseTable;
